import { UtmSource } from '../../../../../../services/exports/Constants';
import { CustomUtmSource } from '../../../../../../views/marketing/tracking-links';

export default {
  title: 'Link di tracciamento',
  utm_sources: {
    [UtmSource.GoogleBusinessProfile]: 'Google business',
    [UtmSource.SocialMedia]: 'Social media',
  },
  form: {
    utm_source: {
      label: 'Sorgente',
      placeholder: 'Seleziona sorgente',
      options: {
        [UtmSource.GoogleBusinessProfile]: 'Google business',
        [UtmSource.SocialMedia]: 'Altri social media',
        [CustomUtmSource.Other]: 'Altro',
      },
    },
    utm_source_details: {
      label: 'Sorgente personalizzata',
      placeholder: 'Inserisci sorgente',
    },
    target_product: {
      label: 'Destinazione',
      placeholder: 'Seleziona destinazione',
    },
    target_url: {
      label: 'URL di destinazione',
      placeholder: 'https://google.com',
    },
    utm_medium: {
      label: 'Mezzo',
      placeholder: 'Inserisci mezzo',
    },
    utm_campaign: {
      label: 'Campagna',
      placeholder: 'Inserisci campagna',
    },
  },
  fields: {
    utm_source: 'Sorgente',
    target_product: 'Destinazione',
    type: 'Tipo',
    utm_medium: 'Mezzo',
    utm_campaign: 'Campagna',
    utm_referrer_id: 'ID referrer',
  },
  buttons: {
    create_auto_links: 'Crea link automatici',
    create_link: 'Crea link',
    create: 'Crea',
    update: 'Aggiorna',
    copy_link: 'Copia link',
    download_qr_code: 'Scarica codice QR',
    edit: 'Modifica',
  },
  modals: {
    auto_links_creation: {
      title: 'Sei sicuro?',
      description:
        'Assicurati di aver completato la configurazione del negozio (sottodominio shop online / dominio vetrina); modificarli dopo la creazione dei link non aggiorna automaticamente i link esistenti!',
    },
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati fallito',
    failed_to_save_changes: 'Salvataggio modifiche fallito',
    changes_got_saved: 'Modifiche salvate',
    link_got_copied: 'Link copiato!',
    failed_to_download_qr_code: 'Download del codice QR fallito',
  },
};
